import React, { Component } from 'react';
import './ConfirmData.css';
import Navbar from '../Components/Navbar/Navbar'
import logoblue from '../../image/logoblue.png'
import { Link } from 'react-router-dom';
import { LinkAPI } from '../../API/API';
import axios from 'axios'


class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailError: "",
      errordatamessage: false,
      errordatamessageText:""
    }
  }
  handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
      [event.target.name]: isCheckbox
        ? event.target.checked
        : event.target.value
    });
  };

  validate = () => {
    let emailError = "";


    if (!this.state.email.includes("@")) {
      emailError = "invalid email";
    }

    if (emailError) {
      this.setState({ emailError });
      return false;
    }

    return true;
  };

  handleSubmit = event => {
    event.preventDefault();
    const { email } = this.state
    const isValid = this.validate();
    if (isValid) {
      console.log(this.state);
      axios.post(`${LinkAPI}/api/businessowner/forgotpassword`,{
        email:email
      }
      ).then(res =>{
        console.log(res)   
        window.location.replace("/ConfirmData");

        }).catch(error=>{
          console.log( error.response.data.message)
          if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            window.location.replace("/Admin/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
            })
        } else {
            this.setState({
                hasError: true,
            })
        }

        })

    }
  };
  render() {
    document.title ="Kayn | Forget Password"; 
    document.getElementsByTagName("META")[1].content="Kayn Forget Password";
    document.documentElement.lang = 'en';
    return (
      <div className="AppEN signin">
        <Navbar />
        <div className='container'>
          <div className="Sign row my-0">
            <div className=" logoform col-6 d-flex align-content-end flex-wrap ">
              <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/"><img className="logo" src={logoblue} alt="Kayn" /></Link>       </div>
              <p className="fontsize2 text-center mb-5 col-12">Your package...your way</p>
            </div>
            <div className="col-md-6 form float-md-right  ">
              <div className="contantform text-center p-4 mt-150">
                <h3 className="fontsize1 my-4">Enter your email</h3>
                <form className="px-lg-5" onSubmit={this.handleSubmit}>
                  <div className="form-group my-4 ">
                    <input type="email" className={"form-control badge-pill p-3 noborder " + (this.state.emailError ? 'is-invalid' : '')} placeholder="Email Address" name="email" value={this.state.email}
                      onChange={this.handleChange} required />
                    <div style={{ fontSize: 12, color: "red" }}>
                      {this.state.emailError}
                    </div>
                   
                  </div>
                  {(this.state.errordatamessage ?
                      <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessagetext}
                      </div> : '')}
                  <button type="submit" className="btn btn-primary badge-pill btn-block shadow p-2 mb-2"  >send</button>
                </form>



                <div className="mt-5 px-5">
                  <p className="fontsize6 my-4">Don't have an account yet ?</p>
                  <Link to="/SignUp" className="btn badge-pill btn-block p-2 border shadow"  >SIGN UP</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
}
export default ForgetPassword;